import { render, staticRenderFns } from "./lainnya.vue?vue&type=template&id=0553b9d8&"
import script from "./lainnya.vue?vue&type=script&lang=js&"
export * from "./lainnya.vue?vue&type=script&lang=js&"
import style0 from "./lainnya.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports